import * as React from "react";
export function useMediaQueries(props) {
  const { viewSizes, baseFontSizePx } = props;
  let mediaQueryLists;
  if (typeof window !== "undefined") {
    mediaQueryLists = Object.entries(viewSizes).map(([_, value]) => [
      value,
      window.matchMedia(`(min-width: ${baseFontSizePx ? value * baseFontSizePx : value}px)`)
      // If using baseFontSizePx, need to multiply by baseFontSizePx to get actual min-width
    ]);
  }
  const getValidViewSize = () => {
    let validViewSize = viewSizes.SMALL;
    if (typeof window !== "undefined" && mediaQueryLists.length > 0) {
      const defaultValidMediaQuery = mediaQueryLists[0];
      const validMediaQueryList = mediaQueryLists.filter((mql) => mql[1].matches).reduce(([validSize, validMql], [currentSize, currentMql]) => {
        if (validSize > currentSize) {
          return [validSize, validMql];
        }
        return [currentSize, currentMql];
      }, defaultValidMediaQuery);
      validViewSize = validMediaQueryList[0];
    }
    return validViewSize;
  };
  const [viewSize, setViewSize] = React.useState(getValidViewSize);
  React.useEffect(() => {
    const handler = () => setViewSize(getValidViewSize);
    if (mediaQueryLists && mediaQueryLists.length > 0) {
      mediaQueryLists.forEach((mql) => mql[1].addListener(handler));
    }
    return () => {
      if (mediaQueryLists && mediaQueryLists.length > 0) {
        mediaQueryLists.forEach((mql) => mql[1].removeListener(handler));
      }
    };
  }, []);
  return viewSize;
}
